import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useUser from "../../../hooks/useUser";
import { searchnormal, profilePicture } from "../../imagepath";
import { socket } from "../../../utils/socket";
// import useToast from "../../../hooks/userToast";
import { useUnreadMessages } from "../../context/UnreadMessagesProvider";
import apiClient from "../../../utils/apiClient";

const ChatSideContent = () => {
  const [users, setUsers] = useState([]);
  const { role, userID } = useUser();
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [senderUserId, setSenderuserId] = useState();
  // const { toastError } = useToast();
  const { setUnreadCount } = useUnreadMessages();
  const queryParams = new URLSearchParams(location.search);
  const selectedUserId = queryParams.get("userId");
  // const [clicekedUser,setClickedUser]=useState([])
  useEffect(() => {
    const receiveMessage = async ({ data, latestMessageTime, messageId }) => {
      console.log("message id-->", messageId.selectedUserId);
      if (selectedUserId == data?.sender_id) {
        await apiClient.patch(
          `chat/updateMessageStatus?messageId=${messageId}`
        );
        // socket.emit("is_message-seen", {
        //   seenBy: userID,
        //   sendBy: data?.sender_id,
        //   messageId,
        // });
      }
      setUsers((prev) => {
        // Update the unread count and latestMessageTime
        const updatedUsers = prev.map((user) =>
          user?.id == data?.sender_id && selectedUserId != data?.sender_id
            ? {
                ...user,
                unreadCount: (user?.unreadCount || 0) + 1,
                latestMessageTime: latestMessageTime,
              }
            : user
        );

        // Clone the array and sort by latestMessageTime in descending order
        return [...updatedUsers].sort(
          (a, b) =>
            new Date(b.latestMessageTime) - new Date(a.latestMessageTime)
        );
      });
      // setUnreadCount((prev) => parseInt(prev) - 1);
    };
    const updateUserList = ({ data, latestMessageTime }) => {
      setUsers((prev) => {
        const updatedUsers = prev.map((user) =>
          user?.id == data?.receiver_id
            ? {
                ...user,
                latestMessageTime: latestMessageTime,
              }
            : user
        );
        return [...updatedUsers].sort(
          (a, b) =>
            new Date(b.latestMessageTime) - new Date(a.latestMessageTime)
        );
      });
    };
    const messageSeen = async ({ seenBy, sendBy, messageId }) => {
      console.log("message seen-->", seenBy, sendBy, messageId);
      setUsers((prev) => {
        const updatedUsers = prev.map((user) =>
          user?.id == sendBy
            ? {
                ...user,
                unreadCount:
                  user?.unreadCount > 0
                    ? user?.unreadCount - 1
                    : user?.unreadCount,
              }
            : user
        );
        return updatedUsers;
        // return [...updatedUsers].sort(
        //   (a, b) =>
        //     new Date(b.latestMessageTime) - new Date(a.latestMessageTime)
        // );
      });
    };
    socket.on("update_userList", updateUserList);
    socket.on("receive-message", receiveMessage);
    socket.on("message-seen", messageSeen);
    return () => {
      socket.off("receive-message", receiveMessage);
      socket.off("update_userList", updateUserList);
      socket.off("message-seen", messageSeen);
    };
  }, [socket, senderUserId]);
  // console.log("users list-->", users);
  useEffect(() => {
    const fetchUsers = async () => {
      const userList = await apiClient.get(
        `chat/getChatUserList?userId=${userID}&role=${role}`
      );
      setUsers(userList?.data?.users);
    };
    fetchUsers();
  }, []);
  return (
    <div className="col-xl-4 col-md-4 d-flex">
      <div className="card chat-box-clinic chat_newscrool">
        <div className="chat_box">
          <h2>Chat</h2>
        </div>
        <div className="chat-widgets">
          <div className="top-liv-search top-chat-search">
            <form>
              <div className="chat-search">
                <div className="form-group me-2 mb-0">
                  <input
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                    className="form-control"
                    placeholder="Search here"
                  />
                  <Link className="btn">
                    <img src={searchnormal} alt="Search" />
                  </Link>
                </div>
              </div>
            </form>
          </div>

          <div className="dffg">
            {users
              .filter((e) =>
                e?.name?.toLowerCase()?.includes(search.toLowerCase())
              )
              ?.map((item) => (
                <div
                  key={item?.id}
                  onClick={async () => {
                    setSenderuserId(item?.id);
                    setUnreadCount(
                      (prev) => parseInt(prev) - parseInt(item?.unreadCount)
                    );
                    setUsers((prev) =>
                      prev.map((user) =>
                        user.id == item?.id ? { ...user, unreadCount: 0 } : user
                      )
                    );
                    navigate(
                      `/chat?userId=${item?.id}&userName=${item?.name}&userRole=${item.roleName}`
                    );
                  }}
                  className={`chat-user-group d-flex align-items-center ${
                    selectedUserId == item?.id ? "chat-active" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                >
                  <div className="img-users call-user">
                    {item?.unreadCount > 0 && selectedUserId != item?.id && (
                      <div className="chat-user-count">
                        <span>{item?.unreadCount}</span>
                      </div>
                    )}
                    <Link to="#">
                      <img src={profilePicture} alt="Profile" />
                    </Link>
                  </div>
                  <div className="chat-users">
                    <div className="user-titles d-flex">
                      <h5>{item?.name}</h5>
                    </div>
                    <div className="user-text d-flex">
                      {<p>{item.roleName ?? ""}</p>}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSideContent;
